import {GenderValue, } from './gender-component.domain';
import {  PropertyOwnerWithAddressValue, } from './property-owner-with-address-component.domain';
import {  TitleSelectionValue, } from './title-selection-component.domain';
import {  YesNoValue} from './yes-no-component.domain';
import { Address2ComponentValue } from './address2-component.domain';
import { CountryOfCitizenshipValue } from './individual-form-component.domain';
import { IdentificationComponentValue } from './identification-component.domain';
import { UploadFileValue } from './file-upload-component.domain';
import {Moment} from 'moment';

export type SoleTraderValue = {
  kind: 'SoleTrader',
  // The saved individual a reopened draft prefilled this from; unset for a person typed in.
  guid?: string,
  title: TitleSelectionValue,
  firstName: string,
  lastName: string,
  middleName?: string,
  // no longer collected by the unified individual-form; kept optional for historical values
  gender?: Exclude<GenderValue, null>,
  dob: Moment,
  hasAlias?: boolean,
  aliasNames?: string | null,
  countryOfCitizenship?: CountryOfCitizenshipValue,
  identification?: IdentificationComponentValue,
  idDocument?: UploadFileValue,
  residentialAddress: Address2ComponentValue,
  propertyOwner: Exclude<PropertyOwnerWithAddressValue, null>,
  // no longer collected per person; a sole trader is always the guarantor
  guarantor?: Exclude<YesNoValue, null>,
  email: string,
  mobile: string,
} | null;

